import api from './client';
import { EggStatus, ChickRearMethod } from '../utils/enums';

export interface Egg {
  id: string;
  status: EggStatus;
  layDate: string;
  clutchId?: string;
  incubationStartDate: string | null;
  incubationDays: number | null;
  bandingNotificationDays: number | null;
  comment: string | null;
  chickRearMethod?: ChickRearMethod | null;
  hatchingDate: string | null;
  bandingDate: string | null;
  bandNumber: string | null;
  failureReason: string | null;
}

export interface Clutch {
  id: string;
  date: string;
  breedingPairId: string;
  eggs: Egg[];
  createdAt?: string;
  updatedAt?: string;
  daysRemainingTillHatching?: number | null;
  breeding_pair?: {
    id: string;
    male_bird?: {
      id: string;
      bandId: string;
      species?: {
        id: string;
        commonName: string;
        hatchingPeriod?: number;
        incubationPeriod?: number;
        daysBeforeBanding?: number;
      };
    };
    female_bird?: {
      id: string;
      bandId: string;
      species?: {
        id: string;
        commonName: string;
        hatchingPeriod?: number;
        incubationPeriod?: number;
        daysBeforeBanding?: number;
      };
    };
    cage_number?: string;
  };
}

export const clutchesApi = {
  getAll: () => api.get<Clutch[]>('clutches'),
  getById: (id: string) => api.get<Clutch>(`clutches/${id}`),
  create: (data: CreateClutchDto) => api.post<Clutch>('clutches', data),
  update: (id: string, data: Partial<Clutch>) => api.put<Clutch>(`clutches/${id}`, data),
  delete: (id: string) => api.delete(`clutches/${id}`),
};

export interface CreateClutchDto {
  date: string;
  breedingPairId: string;
  status?: string;
  notes?: string;
  metadata?: {
    incubationNotes?: string;
    hatchingNotes?: string;
    bandingNotes?: string;
    healthChecks?: {
      date: Date;
      status: 'healthy' | 'concern' | 'issue';
      notes?: string;
    }[];
  };
}

export interface CreateEggDto {
  id: string;
  clutchId?: string;
  status: EggStatus;
  layDate: string;
  chickRearMethod: ChickRearMethod | null;
  incubationStartDate: string | null;
  incubationDays: number | null;
  bandingNotificationDays: number | null;
  comment: string | null;
  hatchingDate: string | null;
  bandingDate: string | null;
  bandNumber: string | null;
  failureReason: string | null;
} 